import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './LaborManagement.frontend.types'

@Injectable({ providedIn: 'root' })
export class LaborManagement_delete_work_class_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { workClassId: number }): Promise<{ reasons?: string[], reflectedWorkClassId?: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.workClassId)) {
      missingRequiredInParams.push('\'workClassId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LaborManagement/functions/delete_work_class_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

